import LarusApp from "./larus/App";

export default LarusApp;
